module.exports = __webpack_public_path__ + "img/ហ្វាតាន់.932d5c04.png";